import React from 'react';
import moment from 'moment';
import { MdClear } from 'react-icons/md';
import { useSelector } from 'react-redux';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { Box, FormControl, Grid, IconButton, TextField } from '@mui/material';

import useStyles from '../../../styles';
import { selectDefaultTheme } from 'GeminiViewerComponent/features/globals/themeSlice';

const StartDateFilter = ({ debouncedSearch, searchString, startDate, endDate, displayOptionId, setStartDate }) => {
    //#region Constants
    //#endregion Constants

    //#region Hooks
    //#endregion Hooks

    //#region State
    //#endregion State

    //#region Selectors
    const theme = useSelector(selectDefaultTheme);
    const classes = useStyles(theme);
    //#endregion Selectors

    //#region Refs
    //#endregion Refs

    //#region Effects
    //#endregion Effects

    //#region Methods
    //#endregion Methods

    //#region Render time calcs
    //#endregion Render time calcs

    return (
        <Grid item={true} xs={12} md={6} lg={6} className={classes.customSelect}>
            <FormControl style={{ position: 'relative' }} fullWidth>
                <LocalizationProvider dateAdapter={AdapterMoment}>
                    <DatePicker
                        label="Start Date"
                        value={startDate}
                        onChange={(newValue) => {
                            const newDate = moment(newValue).format('YYYY-MM-DD[T]HH:mm:ss');
                            if (newDate !== 'Invalid date') {
                                setStartDate(newDate);
                                debouncedSearch(searchString, newDate, endDate, displayOptionId);
                            }
                        }}
                        renderInput={(params) => {
                            delete params?.error;
                            return (
                                <>
                                    <TextField
                                        variant="outlined"
                                        {...params}
                                        sx={{
                                            minWidth: '200px',
                                            width: '100%',
                                        }}
                                    />
                                    <Box
                                        sx={{
                                            position: 'absolute',
                                            right: '35px',
                                            top: '50%',
                                            transform: 'translateY(-50%)',
                                            fontSize: '20px',
                                        }}
                                        className={'clearSelect'}
                                    >
                                        <IconButton
                                            onClick={() => {
                                                setStartDate(null);
                                                debouncedSearch(searchString, null, endDate, displayOptionId);
                                            }}
                                        >
                                            <MdClear className="react-icon" />
                                        </IconButton>
                                    </Box>
                                </>
                            );
                        }}
                    />
                </LocalizationProvider>
            </FormControl>
        </Grid>
    );
};

export { StartDateFilter };
